import styled from 'styled-components';

/**
 * Branded form section heading. Used to title logical sections inside
 * a flat form (e.g., "Customer information", "Products" inside the
 * place-order form). Renders a 3px brand-yellow tab on the left edge
 * + navy text — small visual cue without restructuring the form.
 */
export const StyledSectionTitle = styled.h3`
  display: flex;
  align-items: center;
  gap: 0.625rem;
  margin: 0 0 1rem;
  font-size: 0.9375rem;
  font-weight: 600;
  letter-spacing: -0.005em;
  color: ${({ theme }) => theme.colors.brand.navy};

  &::before {
    content: '';
    width: 3px;
    height: 0.875rem;
    background: ${({ theme }) => theme.colors.brand.yellow};
    border-radius: 2px;
    flex-shrink: 0;
  }
`;
